(function (module) {
  'use strict';

  function contentSearchController($scope, contentSearchBlockService) {
    var vm = this;
    vm.query = '';
    vm.pageSize = 1000;
    vm.pageIndex = 1;
    vm.contentSearch = contentSearch;
    vm.searchInput = searchInput;
    vm.filteron = filteron;
    vm.removefilteron = removefilteron;
    vm.filterCategories = [];
    vm.searchCategories = [];
    vm.groupCategories = [];
    vm.facetCategories = [];
    vm.facetResults = [];
    vm.searchResultGroups = [];
    vm.isFilteredOn = isFilteredOn;

    vm.init = function (searchCategories, facetCategories, groupCategories, doEmptySearchOnLoad) {
      if (searchCategories) {
        vm.searchCategories = searchCategories.split('|');
      }
      if (facetCategories) {
        vm.facetCategories = facetCategories.split('|');
      }
      if (groupCategories) {
        vm.groupCategories = groupCategories.split('|');
      }
      
      if (doEmptySearchOnLoad) {
        contentSearch();
      }
    }


    function searchInput(evt) {
      if (evt.keyCode === 13) {
        contentSearch();
      }
    }

    function isFilteredOn(categoryId) {
      return vm.filterCategories.includes(categoryId);
    }

    function filteron(facetCategoryId) {     
      if (!vm.filterCategories.includes(facetCategoryId)) {
        vm.filterCategories.push(facetCategoryId);
      }
      contentSearch();    
    }

    function removefilteron(facetCategoryId) {      
      if (vm.filterCategories.includes(facetCategoryId)) {
        for (var i = 0; i < vm.filterCategories.length; i++) {          
          if (vm.filterCategories[i] === facetCategoryId) {            
            vm.filterCategories.splice(i, 1);           
          }
        }
      }
      contentSearch();

    }

    function contentSearch() {     
      contentSearchBlockService.search(vm.query, vm.searchCategories, vm.facetCategories, vm.filterCategories, vm.groupCategories, vm.pageIndex, vm.pageSize)
        .then(function success(response) {          
          vm.facetResults = response.data.facets;
          vm.searchResultGroups = response.data.searchResultGroups;


        }, function error(response) {
          console.log('Error calling search api:', response);
        });

    }
  }

  contentSearchController.$inject = ['$scope', 'contentSearchBlockService'];
  module.controller('contentSearchController', contentSearchController);
})(angular.module('app'));